<template>
  <div>
    <v-list-item @click="$emit('click')">
      <v-list-item-avatar v-if="item.protectedFolder">
        <v-icon  class="lighten-1 white--text" style="background-color: cornflowerblue">mdi-folder-lock</v-icon>
      </v-list-item-avatar>
      <v-list-item-avatar v-else>
        <v-icon class="white--text" style="background-color: var(--v-muted-foreground-base);">mdi-folder</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <SubMenu @select="(selection) => $emit(selection, item)" :options="subMenuFolderItems()"/>
      </v-list-item-action>
    </v-list-item>
    <v-divider/>
  </div>
</template>

<script>
import SubMenu from '@/components/sub-menu/index.vue';
import store from '@/common/store';

export default {
  name: 'Folder',
  components: { SubMenu },
  props: {
    item: {
      type: Object,
      required: true,
    },
    allowDelete: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    subMenuFolderItems() {
      const listActions = [];
      listActions.push({ title: 'Configurações Regras Drive', value: 'showAccessPermission' });
      if (!store.getHasMenu() || store.getHasNotificationConfigAuthority()) {
        listActions.push({ title: 'Configurações de Notificações', value: 'showNotification' });
      }
      return listActions;
    },
  },
};
</script>
